import { createFileRoute } from '@tanstack/react-router'
import { PlaidOAuthResume } from '@/features/accounts/PlaidOAuthResume'

// Plaid OAuth bounce-back. When a user picks an OAuth bank (BofA,
// Chase) from Plaid Link Web, the bank redirects them back here
// with an oauth_state_id query param; PlaidOAuthResume re-opens
// Link with the persisted link_token to finish the flow.
export const Route = createFileRoute('/plaid-oauth')({
  component: PlaidOAuthResume,
})
